import { render, staticRenderFns } from "./appraiseIndex.vue?vue&type=template&id=f5c2d022&scoped=true"
import script from "./appraiseIndex.vue?vue&type=script&lang=js"
export * from "./appraiseIndex.vue?vue&type=script&lang=js"
import style0 from "./appraiseIndex.vue?vue&type=style&index=0&id=f5c2d022&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c2d022",
  null
  
)

export default component.exports